/**
 * @file Numeric parsing/formatting for API stats (handles zero-padded strings).
 */

/** Parse API count fields (e.g. "0000011") into a non-negative integer. */
export function parseCount(value: unknown, fallback = 0): number {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.max(0, Math.trunc(value));
  }
  const digits = String(value).replace(/[^\d]/g, '');
  if (!digits) return fallback;
  const n = Number.parseInt(digits, 10);
  return Number.isFinite(n) && n >= 0 ? n : fallback;
}

/** Display integer with locale grouping (e.g. 1,000,000). */
export function formatCount(value: number): string {
  return Math.max(0, Math.trunc(value)).toLocaleString('en-IN');
}
